import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { UserAccessService } from 'src/app/services/app/user-access.service';
import { ExtractedPerms } from '@/models/user-data.model';
import { ExemptionService } from '@/services/api/exemption.service';
import { AppAuthService } from '@/services/app/auth.service';
import { BinderService } from '@/services/api/binder.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { ExcemptionStatusService } from '@/services/app/excemption-status.service';


@Component({
    selector: 'app-respond',
    imports: [ButtonModule],
    template: `
    <div class="text-center">
  <div class="text-900 font-medium mb-2 text-xl">Respond to Exemption Request</div>
  <p class="mt-0 mb-4 p-0 line-height-3">Approve, Deny, or Cancel the request. Approving this request will allow this
    contract to circumvent the standard design agreement process. The reason given for this request is as follows:</p>
  <div [innerHTML]="reason"
    class="surface-ground mt-0 mb-4 p-0 text-left align-items-start justify-content-start inline-height-3">
  </div>
  <div class="button-container">
    <p-button icon="pi pi-check" [rounded]="false" [label]="'Cancel Request'" (click)="cancelRequest()"
      [disabled]="!getPerm() && !editAccess" class="m-3">
    </p-button>
    <p-button icon="pi pi-check" [rounded]="false" class="m-3" [disabled]="!getPerm()" (click)="respondToRequest(false)"
      [label]="'Deny Request'">
    </p-button>
    <p-button icon="pi pi-check" [rounded]="false" class="m-3" [label]="'Approve Request'"
      (click)="respondToRequest(true)" [disabled]="!getPerm()">
    </p-button>
  </div>
</div>
    `,
    styles: `
    .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
    `
})
export class ExRespondComponent implements OnInit, OnDestroy{
  permissionsSubscription!: Subscription;
  reasonSubscription!: Subscription;
  editAccess: boolean = false;
  binderId:number = 0;
  reason: string | null = null;

  constructor(
    private exemptionService: ExemptionService, 
    private appAuthService: AppAuthService,
    private currentBinderService: BinderService,
    private userAccessService: UserAccessService,
    private binderDialogService: BinderDialogService,
    private messageService: MessageService,
    private exemptionStatusService: ExcemptionStatusService
  ) {
    effect(() => {
      const binder = this.currentBinderService.currentBinder();
      const access = this.userAccessService.binderEditAccess();
      if(binder) {
        this.binderId = binder?.BinderID ?? 0;
      }
      this.editAccess = access;
    })
  }

  ngOnInit(): void {
    this.reasonSubscription = this.exemptionStatusService.reason$.subscribe(reason => {
      this.reason = reason;
    });
  }

  get permissions() {
    return this.appAuthService.userPerms();
  }

  ngOnDestroy(): void {
    this.permissionsSubscription.unsubscribe();
    this.reasonSubscription.unsubscribe();
  }

  cancelRequest() {
    this.binderDialogService.closeDialog();
    this.exemptionService.cancelRequest(this.binderId).subscribe((res: any) => {
      console.log(res);
      this.messageService.add({severity:'success', summary: 'Success', detail: 'Request Cancelled', life: 3000});
      
    },
    (error) => {
      console.log(error);
      this.messageService.add({severity:'error', summary: 'Error', detail: `Error Cancelling Request`, life: 3000});
    }
  );
  }

  respondToRequest(approve:boolean) {
    this.binderDialogService.closeDialog();
    const action = approve ? 'Approved' : 'Rejected';
    this.exemptionService.respondToRequest(this.binderId, approve).subscribe((res: any) => {
      console.log(res);
      this.messageService.add({severity:'success', summary: 'Success', detail: `Request ${action}`, life: 3000});
      
    },
    (error) => {
      console.log(error);
      this.messageService.add({severity:'error', summary: 'Error', detail: `Error Responding to Request`, life: 3000});
    }
  );
  }

  getPerm(): boolean { 
    if(this.permissions) {
      const perm = this.permissions.find((perm) => perm.permType === 'edit' && perm.dataTable==='exemptions' && perm.FID === null);
      return perm ? true : false;
    }
    return false;
  }

}
